<template>
	<VerticalLayout>
		<StatsChartTitleWithDescription
			titleKey="stats.by-gnss.gridpointChartTitle"
			descriptionKey="stats.by-gnss.gridpointChartTitleTooltip"
			titleClass="pd-lg-x pd-md-top"
		/>
		<TypographyText v-if="!multiCnetEnabled" class="pd-lg-x">
			<InfoCircleOutlined class="pd-sm-x pd-left-0" />{{ $t('home-map.messages.noDataForCNet') }}
		</TypographyText>
		<TimeSeriesChart :isLoading="isLoading" :series="series" :options="chartOptions" :height="500" />
	</VerticalLayout>
</template>

<script>
import { computed } from 'vue';
import { TypographyText } from 'ant-design-vue';
import { InfoCircleOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';
import { getBaseOptions, generateSeries, setXAxisRange } from '@/utils/chartsUtils';
import MapHelpers from '@/components/map/utils/MapHelpers';

import VerticalLayout from '@/components/common/VerticalLayout.vue';
import TimeSeriesChart from '@/components/stats/TimeSeriesChart.vue';
import StatsChartTitleWithDescription from '@/components/stats/StatsChartTitleWithDescription.vue';


export default {
	components: {
		TypographyText,
		VerticalLayout,
		TimeSeriesChart,
		InfoCircleOutlined,
		StatsChartTitleWithDescription,
	},
	props: {
		apiData: {
			type: Object,
			required: true,
		},
		isLoading: {
			type: Boolean,
			required: true,
		},
		datesRangeSafe: {
			type: Array,
			required: true,
		},
	},
	setup(props) {
		const multiCnetEnabled = Consts.MULTI_CNET_ENABLED;
		const getSeriesKey = item => {
			return MapHelpers.getGnssDataDisplay(item.client).name;
		};
		const getValue = item => item.final_value;

		const series = computed(() => generateSeries({
			items: props.apiData.statsItems,
			getSeriesKeyFn: getSeriesKey,
			getValueFn: getValue,
			seriesStep: props.apiData.period,
			showNullAsZero: false,
		}).series);

		const chartOptions = computed(() => {
			let options = getBaseOptions('satellites_per_gp_count', series.value);
			setXAxisRange(options, props.datesRangeSafe);
			options.yaxis.title.text = 'Count';
			options.yaxis.decimalsInFloat = 0;
			return options;
		});

		return {
			multiCnetEnabled,
			series,
			chartOptions,
		};
	},
}
</script>
